<template>
  <div>
    <div class="modal-card" style="width: auto" v-if="obj != null">
      <b-loading :active.sync="isloading" :can-cancel="false"></b-loading>
      <header class="modal-card-head">
        <p class="modal-card-title">{{ $t('index.register_client_popup_' + obj.licenseInfo.byod_type) }} Mobile Auth</p>
      </header>
      <section class="modal-card-body">
        <div class="">
          <div class="columns">
            <div class="column">
              <b-field :label="'* ' + $t('index.select_configuration_' + obj.licenseInfo.byod_type)" :type="obj.newKeyValues.configurationId?'default':'is-danger'">
                <b-select @input="selectRoom" placeholder="Select the configuration and room" required v-model="obj.newKeyValues.configurationId" expanded>
                  <option v-for="conf in getFreeConfigurations(obj)" v-bind:value="conf.id" v-bind:key="conf.id">{{ conf.tag }}: {{ conf.name }}</option>
                </b-select>
              </b-field>
            </div>
          </div>
          <!-- <div>
            <b-field>
              <b-radio v-model="obj.newKeyValues.limitType" native-value="1" type="is-danger">
                {{ $t('index.limited_by_datetime') }}
              </b-radio>
            </b-field>
            <b-field>
              <b-radio v-model="obj.newKeyValues.limitType" native-value="2" type="is-info">
                {{ $t('index.unlimited_duration') }}
              </b-radio>
            </b-field>
          </div>
          <br>
          <div class="limit_type_2" v-if="obj.newKeyValues.limitType == 2">
            <div class="columns">
              <div class="column">
                <template>
                  <b-field :label="$t('index.check_frequency')">
                    <b-input type="number" min="1" max="30" icon="clock" :placeholder="$t('index.days')" v-model="obj.newKeyValues.frequencyCheckPeriod" />
                  </b-field>
                </template>
              </div>

            </div>
          </div> -->
          <div v-if="obj.newKeyValues.limitType == 1" class="limit_type_1">
            <div class="columns">
              <div class="column">
                <template>
                  <b-field :label="$t('index.arrival_date_' + obj.licenseInfo.byod_type)">
                    <b-datepicker :min-date="minDate" @input="onchangeDateLifeFrom($event, obj, objIndx)" v-model="obj.newKeyValues.dateLifeFrom" placeholder="Click to select..." icon="calendar-alt">
                    </b-datepicker>
                  </b-field>
                </template>
              </div>
              <div class="column">
                <template>
                  <b-field :label="$t('index.arrival_time_' + obj.licenseInfo.byod_type)">
                    <b-timepicker hour-format="24" v-model="obj.newKeyValues.dateLifeFrom" placeholder="Type or select a date..." icon="clock" :readonly="false"> </b-timepicker>
                  </b-field>
                </template>
              </div>
            </div>

            <div class="columns">
              <div class="column">
                <template>
                  <b-field :label="$t('index.departure_date_' + obj.licenseInfo.byod_type)">
                    <b-datepicker :min-date="minDate" @input="onchangeDateLifeTo($event, obj, objIndx)" v-model="obj.newKeyValues.dateLifeTo" placeholder="Click to select..." icon="calendar-alt">
                    </b-datepicker>
                  </b-field>
                </template>
              </div>
              <div class="column">
                <template>
                  <b-field :label="$t('index.departure_time_' + obj.licenseInfo.byod_type)">
                    <b-timepicker hour-format="24" v-model="obj.newKeyValues.dateLifeTo" placeholder="Type or select a date..." icon="clock" :readonly="false"> </b-timepicker>
                  </b-field>
                </template>
              </div>
            </div>

            <div class="columns session_block">
              <div class="column">
                <div class="field">
                  <label class="label">{{ $t('index.session_time') }}</label>
                  <b-checkbox v-model="obj.newKeyValues.sessionTimeOption">{{ $t('index.custom_time_cb') }}</b-checkbox>
                </div>
              </div>
              <div class="column">
                <div class="field">
                  <b-tooltip label="Default and max value 30days (43200 minutes)" multilined>
                    <label class="label">{{ !obj.newKeyValues.sessionTimeOption ? $t('index.default') : $t('index.custom_time') }}</label>
                  </b-tooltip>
                  <div v-if="!obj.newKeyValues.sessionTimeOption">
                    <b>30 {{ $t('index.days') }}</b>
                  </div>
                  <div v-else>
                    <b-field>
                      <b-input type="number" min="1" max="43200" icon="clock" :placeholder="$t('index.minutes')" v-model="obj.newKeyValues.sessionTimeValue" />
                    </b-field>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="columns">
            <div class="column">
              <div class="field">
                <label class="label">{{ $t('index.phone_number') }}</label>
                <div class="control">
                  <b-field>
                    <b-input
                      v-facade="'+# (###) ### - ## - ##'"
                      :masked="false"
                      @input.native="onInput"
                      type="text" icon="phone"
                      placeholder="+_ (___) ___−__−__"
                      v-model="obj.newKeyValues.phone" />
                  </b-field>
                </div>
              </div>

              <div class="field">
                <label class="label">{{ $t('index.comment') }}</label>
                <div class="control">
                  <b-field>
                    <b-input
                      type="textarea"
                      maxlength="255"
                      v-model="obj.newKeyValues.comment" />
                  </b-field>
                </div>
              </div>
            </div>
          </div>

          <!-- <div class="columns">
            <div class="column">
              <div class="field">
                <template>
                  <b-field :label="$t('index.activation_panels_limit')">
                    <b-input :placeholder="$t('index.activation_panels_limit_placeholder')" type="number" min="1" icon="clock" v-model="obj.newKeyValues.activationsCount" />
                  </b-field>
                </template>
              </div>
            </div>
          </div> -->

          <div class="columns is-multiline" style="max-width: 480px" v-if="fields.length">
            <div class="column is-half" v-for="(customField, i) in fields" :key="i" v-show="customField.edit">
              <div class="field">
                <label class="label">{{ customField.name }}</label>
                <div class="control">
                  <b-field>
                    <b-input type="text" @input="setCustomValue($event, customField, i)" v-model="customField.value"> </b-input>
                  </b-field>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <footer class="modal-card-foot columns is-gapless">
        <div class="column is-half">
          <button class="button" type="button" @click="$parent.close()">{{ $t('index.cancel') }}</button>
        </div>
        <div class="column is-half has-text-right">
          <button :disabled="!validate" class="button is-success" @click="addNewKey(objIndx, obj)">{{ $t('index.register') }}</button>
        </div>
      </footer>
    </div>
  </div>
</template>
<script>
const today = new Date();
var moment = require('moment-timezone');
import FDateTime from './FDateTime.vue';
// import Cleave from 'vue-cleave-component';
import { InputFacade, facade, filter } from 'vue-input-facade' 
export default {
  components: {
    FDateTime,
    InputFacade,
    // Cleave
  },
  directives: { facade },
  filters: { facade: filter },
  props: ['objIndx', 'objData'],
  data() {
    return {
      obj: null,
      minDate: new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1),
      fields: [],
      isloading: false,
      phoneFormat: '',
    };
  },
  computed:{
    validate(){
      if(!this.obj) return false;
      if(!this.obj.newKeyValues.configurationId) {
        return false
      }

      if(this.obj.newKeyValues.limitType == 2) {
        const frequency = parseInt(this.obj.newKeyValues.frequencyCheckPeriod)
        if(Number.isNaN(frequency) ||frequency <=0 || frequency > 30) {
          return false
        }
      }

      if(this.phoneFormat.length < 11) {
        return false
      }

      return true
    },
  },
  beforeMount() {
    this.obj = this.objData;
    this.obj.newKeyValues.limitType = 2
    this.obj.newKeyValues.frequencyCheckPeriod = 30
    this.obj.newKeyValues.phone = '+7 ('
  },
  methods: {
    onInput(event) {
      // if (event.target.unmaskedValue.length <= 2) {
      //   event.target.unmaskedValue = ''
      // }
      this.phoneFormat = event.target.unmaskedValue
    },
    setCustomValue(event, curField, indexField) {
      this.$set(this.fields[indexField], 'defVal', curField.devValue === event);
    },
    selectRoom(confId) {
      let [roomData] = this.obj.configurations.filter((c) => c.id === confId);
      // console.log(event);
      this.$http({
        method: 'post',
        url: `${this.$backendHost}/frontend/api/roomfields/get`,
        transformResponse: [
          (data) => {
            return JSON.parse(data);
          },
        ],
        data: roomData,
      })
        .then((response) => {
          if (response.data.status) {
            console.error(response.data.error);
          } else {
            this.fields = response.data.fields
              .map((f) => {
                f.devValue = f.value;
                f.defVal = true;
                return f;
              })
              .filter((f) => f.type === 1);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    onchangeDateLifeFrom(data, object, objIndex) {
      if (object.defArrivalTime && data.getHours() === 0 && data.getMinutes() === 0) {
        let defArrivalTime = new Date(object.defArrivalTime);
        data.setHours(defArrivalTime.getHours(), defArrivalTime.getMinutes(), 0);
        this.$set(this.initResponse.objects[objIndex].newKeyValues, 'dateLifeFrom', data);
      }
    },
    onchangeDateLifeTo(data, object, objIndex) {
      if (object.defDepartureTime && data.getHours() === 0 && data.getMinutes() === 0) {
        let defDepartureTime = new Date(object.defDepartureTime);
        data.setHours(defDepartureTime.getHours(), defDepartureTime.getMinutes(), 0);
        this.$set(this.initResponse.objects[objIndex].newKeyValues, 'dateLifeTo', data);
      }
    },
    getFreeConfigurations(object) {
      // collecting busy configs
      if (object.multyTokensConfig) {
        return object.configurations;
      }

      let lockedConfigs = object.tokens.reduce((prev, cur) => {
        if (cur.active) {
          prev.push(cur.Configuration.id);
        }
        return prev;
      }, []);
      // exclude busy configs from aviable list
      return object.configurations.filter((conf) => lockedConfigs.indexOf(conf.id) == -1);
    },

    async addNewKey(objIndex, objectData) {
      try {
        this.isloading = true
        const response = await this.$http({
          method: 'post',
          url: `${this.$backendHost}/frontend/api/keys/add`,
          transformResponse: [
            (data) => {
              return JSON.parse(data);
            },
          ],
          data: {
            timezone: moment.tz.guess(),
            comment: objectData.newKeyValues.comment || '',
            clientName: objectData.newKeyValues.clientName || '',
            comment: objectData.newKeyValues.comment || '',
            // email: objectData.newKeyValues.email,
            // phone: objectData.newKeyValues.phone,
            phone: this.phoneFormat,
            configurationId: objectData.newKeyValues.configurationId,
            objectId: objectData.newKeyValues.objectId,
            limit: 0,
            // dateLifeTo: objectData.newKeyValues.dateLifeTo.getTime(),
            dateLifeFrom: objectData.newKeyValues.dateLifeFrom.getTime(),
            sessionTime: !objectData.newKeyValues.sessionTimeOption ? null : objectData.newKeyValues.sessionTimeValue,

            limitType: objectData.newKeyValues.limitType || 1,
            frequencyCheckPeriod: objectData.newKeyValues.frequencyCheckPeriod || null,
            activationsCount: objectData.newKeyValues.activationsCount || null,

            fields: this.fields,
          },
        });

        if (response.data.status) {
          this.$toast.open({
            message: response.data.error,
            position: 'is-bottom-right',
            type: 'is-error',
            container: 'div.modal-card',
          });
          this.isloading = false
          return;
        }

        this.$emit('init_response_push', {
          objIndex: objIndex,
          tokenData: response.data.tokenData,
        });
        
        // this.$emit('init_load_data');
        
        this.$parent.close();

        if (objectData.showQrCode) {
          // show qr imidiately
          this.$emit('show_qr', {
            objIndex: objIndex,
            tokenData: response.data.tokenData,
          });
        }
      } catch (error) {
        this.$toast.open({
          message: error,
          position: 'is-bottom-right',
          type: 'is-error',
          container: 'div.modal-card',
        });
      }
      this.isloading = false
    },
  },
};
</script>

<style>
.label {
  color: #444;
  font-weight: 400;
}
.session_block {
  background: rgb(245, 245, 245);
  margin: 0px;
  margin-bottom: 15px;
  border-radius: 5px;
}

.limit_type_1{
  border-top: 5px solid #EB4C64;
  padding-top: 10px;
}

.limit_type_2{
  border-top: 5px solid #4A9CE7;
  padding-top: 10px;
}


@media screen and (min-width: 768px) {
  .modal-card{
    min-width: 500px;
  }
}
</style>



// WEBPACK FOOTER //
// Registermauth.vue?5500813d